<!-- First-run banner -->
@if (consent.showBanner() && !consent.prefsOpen()) {
  <div class="fixed inset-x-0 bottom-0 z-[1100] p-3 sm:p-4">
    <div class="mx-auto max-w-3xl rounded-2xl border border-line dark:border-line-dark bg-white dark:bg-night-surface shadow-xl px-5 py-4">
      <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <p class="text-sm text-ink-mid dark:text-night-mid leading-relaxed">
          We use cookies. Necessary ones keep you signed in. With your consent we also use analytics and
          marketing cookies. See our
          <a routerLink="/privacy" class="font-semibold text-green dark:text-green-light hover:underline">Privacy Policy</a>.
        </p>
        <div class="flex flex-wrap items-center gap-2 shrink-0">
          <button type="button" (click)="consent.openPrefs()"
                  class="px-3 py-1.5 rounded-full text-xs font-bold text-ink dark:text-night-text border border-line dark:border-line-dark hover:border-green dark:hover:border-green-light transition-colors">
            Manage
          </button>
          <button type="button" (click)="consent.rejectAll()"
                  class="px-3 py-1.5 rounded-full text-xs font-bold text-ink dark:text-night-text border border-line dark:border-line-dark hover:border-green dark:hover:border-green-light transition-colors">
            Reject non-essential
          </button>
          <button type="button" (click)="consent.acceptAll()"
                  class="px-4 py-1.5 rounded-full text-xs font-bold text-white bg-green hover:bg-green-light dark:bg-green-light dark:hover:bg-green-glow dark:!text-night-bg transition-colors">
            Accept all
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Preferences modal -->
@if (consent.prefsOpen()) {
  <div class="fixed inset-0 z-[1200] flex items-end sm:items-center justify-center p-3 sm:p-4">
    <div class="absolute inset-0 bg-black/50" (click)="consent.closePrefs()"></div>

    <div class="relative w-full max-w-lg rounded-2xl border border-line dark:border-line-dark bg-white dark:bg-night-surface shadow-2xl">
      <div class="px-5 sm:px-6 py-4 border-b border-line dark:border-line-dark">
        <h2 class="text-lg font-extrabold tracking-tight text-ink dark:text-night-text">Cookie preferences</h2>
        <p class="mt-0.5 text-xs text-ink-mid dark:text-night-mid">Choose which cookies we can use. You can change this anytime.</p>
      </div>

      <div class="px-5 sm:px-6 py-4 space-y-4">
        <!-- Necessary -->
        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0">
            <p class="text-sm font-semibold text-ink dark:text-night-text">Necessary</p>
            <p class="mt-0.5 text-xs text-ink-mid dark:text-night-mid leading-relaxed">
              Required to sign in and keep the app working. Always on.
            </p>
          </div>
          <span class="shrink-0 text-xs font-bold text-green dark:text-green-light">Always active</span>
        </div>

        <!-- Analytics -->
        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0">
            <p class="text-sm font-semibold text-ink dark:text-night-text">Analytics</p>
            <p class="mt-0.5 text-xs text-ink-mid dark:text-night-mid leading-relaxed">
              Helps us monitor errors and performance. No payroll data is collected, and we don't track your account pages.
            </p>
          </div>
          <button type="button" role="switch" [attr.aria-checked]="analytics()"
                  (click)="analytics.set(!analytics())"
                  class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors"
                  [class.bg-green]="analytics()" [class.dark:bg-green-light]="analytics()"
                  [class.bg-line]="!analytics()" [class.dark:bg-line-dark]="!analytics()">
            <span class="inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform"
                  [class.translate-x-5]="analytics()" [class.translate-x-0.5]="!analytics()"></span>
          </button>
        </div>

        <!-- Marketing -->
        <div class="flex items-start justify-between gap-4">
          <div class="min-w-0">
            <p class="text-sm font-semibold text-ink dark:text-night-text">Marketing</p>
            <p class="mt-0.5 text-xs text-ink-mid dark:text-night-mid leading-relaxed">
              Lets us measure our marketing (Meta Pixel, Google Ads, Google Analytics). Only runs on public pages.
            </p>
          </div>
          <button type="button" role="switch" [attr.aria-checked]="marketing()"
                  (click)="marketing.set(!marketing())"
                  class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors"
                  [class.bg-green]="marketing()" [class.dark:bg-green-light]="marketing()"
                  [class.bg-line]="!marketing()" [class.dark:bg-line-dark]="!marketing()">
            <span class="inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform"
                  [class.translate-x-5]="marketing()" [class.translate-x-0.5]="!marketing()"></span>
          </button>
        </div>
      </div>

      <div class="px-5 sm:px-6 py-4 border-t border-line dark:border-line-dark flex flex-wrap items-center justify-end gap-2">
        <button type="button" (click)="consent.rejectAll()"
                class="px-3 py-1.5 rounded-full text-xs font-bold text-ink dark:text-night-text border border-line dark:border-line-dark hover:border-green dark:hover:border-green-light transition-colors">
          Reject all
        </button>
        <button type="button" (click)="saveChoices()"
                class="px-3 py-1.5 rounded-full text-xs font-bold text-ink dark:text-night-text border border-line dark:border-line-dark hover:border-green dark:hover:border-green-light transition-colors">
          Save choices
        </button>
        <button type="button" (click)="consent.acceptAll()"
                class="px-4 py-1.5 rounded-full text-xs font-bold text-white bg-green hover:bg-green-light dark:bg-green-light dark:hover:bg-green-glow dark:!text-night-bg transition-colors">
          Accept all
        </button>
      </div>
    </div>
  </div>
}
